angular
  .module('contrast.factory.protection.rules', [])
  .factory('ProtectionRulesFactory', function ($http, $q, UserService) {
    return {
      getRules: function () {
        return $http.get(UserService.buildAPIUrl('/protection/rules'))
      },
      getEnvProtectionRule: function (appId, ruleId) {
        return $http.get(
          UserService.buildAPIUrl(
            '/protection/rules/env/' + appId + '/' + ruleId
          )
        )
      },
      editEnvProtectionLevel: function (appId, ruleId, environment, level) {
        return $http.post(
          UserService.buildAPIUrl(
            '/protection/rules/env/' +
              appId +
              '/' +
              ruleId +
              '/' +
              environment +
              '/' +
              level
          )
        )
      },

      //Exclusions
      toggleDefendStatus: function (appId, exclusionId) {
        return $http.put(
          UserService.buildAPIUrl(
            '/protection/rules/exclusions/' +
              appId +
              '/' +
              exclusionId +
              '/defend'
          )
        )
      },

      getProtectionPolicies: function (appId) {
        return $http.get(UserService.buildAPIUrl('/protection/policy/' + appId))
      },

      getAllExclusions: function (keyword, limit, offset, sort, expand) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/exclusions'),
          params: {
            keyword: keyword,
            limit: limit,
            offset: offset,
            sort: sort,
            expand: expand || ''
          },
          timeout: httpTimeout.promise
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },

      //Protect Rule and Cve Shields
      getOnlyProtectionRules: function (params) {
        return $http.get(UserService.buildAPIUrl('/protection/rules/rules'), {
          params: params
        })
      },
      getProtectionRulesQuickFilters: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/protection/rules/filters/quick'),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getProtectionRuleFilters: function (ruleId, params) {
        return $http.get(
          UserService.buildAPIUrl(
            '/protection/rules/rules/' + ruleId + '/filters/quick'
          ),
          { params: params }
        )
      },
      getProtectionRuleDrilldown: function (ruleId, params) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/protection/rules/rules/' + ruleId),
          params: params,
          timeout: httpTimeout.promise
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },

      getOnlyCveShields: function (params) {
        return $http.get(UserService.buildAPIUrl('/protection/rules/cve'), {
          params: params
        })
      },
      getCveShieldFilters: function (ruleId, params) {
        return $http.get(
          UserService.buildAPIUrl(
            '/protection/rules/cve/' + ruleId + '/filters/quick'
          ),
          { params: params }
        )
      },
      getCveShieldDrilldown: function (ruleId, params) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/protection/rules/cve/' + ruleId),
          params: params,
          timeout: httpTimeout.promise
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      }
    }
  })
